import { render, staticRenderFns } from "./Playlists.vue?vue&type=template&id=52331179&scoped=true&"
import script from "./Playlists.vue?vue&type=script&lang=ts&"
export * from "./Playlists.vue?vue&type=script&lang=ts&"
import style0 from "./Playlists.vue?vue&type=style&index=0&id=52331179&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52331179",
  null
  
)

export default component.exports